import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import config from '../appconfig/config.json';

const PersonIncomeCPF = (props) => {

    const {data} = props;
   
    return(
        <div className='inputPair'>
            <div className="scroll-row">
                <div className="cpf-col bordercpf-left">
                    <div className="headerCpf-left">
                        <div className='cpf-title-col txt-ws-initial'>
                            Year of assessment: {data.firstYear.year !=null ? data.firstYear.year:'NA'}
                        </div>
                    </div>
                  
                    <div className='col-12'>
                        <div className='incomeBrkdownLeft txt-ws-initial'>
                            {'Type'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.firstYear.taxCategory !== null? data.firstYear.taxCategory:'-'}
                        </div>
                    </div>       
                    <div className='col-12'>
                        <div className="row divgreylineCpf" />
                    </div>

                    <div className='col-12'>
                        <div className='incomeBrkdownLeft txt-ws-initial'>
                            {'Assessable Income'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.firstYear.assessableIncome !== null?data.firstYear.assessableIncome:'-'}
                        </div>
                    </div>

                    <div className='col-12'>
                        <div className="row divgreylineCpf" />
                    </div>

                    <div className='col-12'>
                        <div style={{width:'100%',paddingTop:'3%'}} className='txt-ws-initial'>
                        {'Income Breakdown'}
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' />
                            &nbsp;{'Employment'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.firstYear.employment !== null? data.firstYear.employment:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' />
                            &nbsp;{'Trade'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.firstYear.trade !== null?data.firstYear.trade:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' />
                            &nbsp;{'Rent'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.firstYear.rent !== null?data.firstYear.rent:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' />
                            &nbsp;{'Interest'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.firstYear.interest !== null?data.firstYear.interest:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' />
                            &nbsp;{'Tax Clearance'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.firstYear.taxClearance !== null? data.firstYear.taxClearance:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' />
                            &nbsp;{'Tax Category'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.firstYear.taxCategory !== null? data.firstYear.taxCategory:'-'}
                        </div>
                        </div> 
                    </div>
                </div>
                <div className="cpf-col bordercpf-right">
                    <div className="headerCpf-right">
                        <div className='cpf-title-col txt-ws-initial'>
                            Year of assessment: {data.secondYear.year !== null? data.secondYear.year:'NA'}
                        </div>
                    </div>
                 
                    <div className='col-12'>
                        <div className='incomeBrkdownLeft txt-ws-initial'>
                            {'Type'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.secondYear.taxCategory !== null? data.secondYear.taxCategory:'-'}
                        </div>
                    </div>

                    <div className='col-12'>
                        <div className="row divgreylineCpf" />
                    </div>

                    <div className='col-12'>
                        <div className='incomeBrkdownLeft txt-ws-initial'>
                            {'Assessable Income'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.secondYear.assessableIncome !== null? data.secondYear.assessableIncome:'-'}
                        </div>
                    </div>

                    <div className='col-12'>
                        <div className="row divgreylineCpf" />
                    </div>
                 
                    <div className='col-12'>
                        <div style={{width:'100%',paddingTop:'3%'}} className='txt-ws-initial'>
                        {'Income Breakdown'}
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' /> 
                            &nbsp;{'Employment'}  
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.secondYear.employment !==null?data.secondYear.employment:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' /> 
                            &nbsp;{'Trade'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.secondYear.trade !== null?data.secondYear.trade:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' /> 
                            &nbsp;{'Rent'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.secondYear.rent !== null?data.secondYear.rent:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' /> 
                            &nbsp;{'Interest'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.secondYear.interest !== null?data.secondYear.interest:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' /> 
                            &nbsp;{'Tax Clearance'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.secondYear.taxClearance !== null?data.secondYear.taxClearance:'-'}
                        </div>
                        </div>
                        <div style={{width:'100%'}}>
                        <div className='incomeBrkdownLeft'>
                            <span className='dotIncomeBreakdownList txt-ws-initial' />
                            &nbsp;{'Tax Category'}
                        </div>
                        <div className='incomeBrkdownRight txt-ws-initial'>
                            {data.secondYear.taxCategory !== null? data.secondYear.taxCategory:'-'}
                        </div>
                        </div>   
                    </div>
                </div>
            </div>
            <br/>
        </div>
    )
}

export default PersonIncomeCPF;